export default __webpack_public_path__ + "static/media/home.79786be2.svg";